import Modal from '@mui/material/Modal';
import { type ReactElement } from 'react';

interface ModalWrapperProps {
  children: ReactElement;
  open: boolean;
  onClose?: () => void;
  'aria-labelledby'?: string;
  'aria-describedby'?: string;
}

const MUIModal = ({
  children,
  open,
  onClose,
  'aria-labelledby': ariaLabelledBy,
  'aria-describedby': ariaDescribedBy,
}: ModalWrapperProps) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby={ariaLabelledBy}
      aria-describedby={ariaDescribedBy}
    >
      {children}
    </Modal>
  );
};

export default MUIModal;
